/*document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;
  let isDrawerOpen = false;

  function initSwiper() {
    const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
    if (!container) return;

    if (swiperInstance && swiperInstance.destroy) {
      swiperInstance.destroy(true, true);
    }

    swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  function showLoader() {
    const loader = document.createElement("div");
    loader.id = "qv-loader";
    loader.style.position = "fixed";
    loader.style.top = 0;
    loader.style.left = 0;
    loader.style.width = "100%";
    loader.style.height = "100%";
    loader.style.background = "rgba(255,255,255,0.7) url('/spinner.gif') no-repeat center center";
    loader.style.zIndex = 9999;
    document.body.appendChild(loader);
  }

  function hideLoader() {
    const loader = document.getElementById("qv-loader");
    if (loader) loader.remove();
  }

function refreshCartDrawer(forceOpen = false) {
  fetch("/?sections=cart-drawer")
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(data => {
      const drawerHTML = data['cart-drawer'];
      const drawerWrapper = document.querySelector(".drawer--cart");
      if (!drawerWrapper) return;

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(drawerHTML, "text/html");
      const newDrawerContent = newDoc.querySelector(".drawer--cart");

      if (newDrawerContent) {
        // Instead of replacing the whole drawer, replace only its inner content
        drawerWrapper.innerHTML = newDrawerContent.innerHTML;
      }

      // Only open the drawer if it's not already open
      if (forceOpen && !drawerWrapper.classList.contains("is-open")) {
        drawerWrapper.classList.add("is-open");
      }

      initSwiper();
      hideLoader();
    })
    .catch(err => {
      console.error("Failed to refresh full cart drawer:", err);
      hideLoader();
    });
}

  document.body.addEventListener("click", function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (!quickBtn) return;

    const handle = quickBtn.dataset.handle;
    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then(res => res.ok ? res.json() : Promise.reject(res.status))
      .then(product => {
        let imageHtml = product.images.map(img => `
          <div class="qv-image-slide">
            <img src="${img}" alt="${product.title}" style="max-width:100%;">
          </div>`).join('');

        const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || '';

        let wrapperHtml = `
          <h3 class="qv-title">${product.title}</h3>
          <p class="qv-price">Rs.${(product.price / 100).toFixed(2)}</p>
          <div class="qv-desc">${product.description}</div>
          <form id="qv-form">
            <label class="label-qw">Select Size: Choose an option</label><br>
            <select name="id" id="variant-pr">
              ${product.variants.map(v => `<option value="${v.id}">${v.title}</option>`).join('')}
            </select>
            <div class="quantity-wrapper">
              <button type="button" id="qv-minus">–</button>
              <input type="number" id="qv-qty" value="1" min="1">
              <button type="button" id="qv-plus">+</button>
            </div>
            <button type="button" id="qv-add">Add to cart</button>
            <button type="button" id="qv-buy-now">Buy it now</button>
            ${socialIcons}
          </form>`;

        const popup = document.getElementById("quick-view-popup");
        popup.innerHTML = `<span class="close-qw" style="    cursor: pointer;
    position: sticky;
    top: -1px !important;
    right: 0px !important;
    font-size: 18px;
    margin-left: auto;">X</span><div class="qv-image">${imageHtml}</div><div class="qv-wrapper">${wrapperHtml}</div>`;
        popup.classList.add("visible");
        document.querySelector(".wrapper-screen")?.classList.add("visible");

        setTimeout(() => {
          if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
            $('.qv-image').slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }
        }, 500);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        alert("Unable to load product data.");
      });
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = parseInt(input.value) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) - 1);
    }

    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      showLoader();
      const variantId = document.querySelector("#qv-form select[name='id']")?.value;
      const quantity = parseInt(document.querySelector("#qv-qty")?.value || 1);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(() => {
          if (e.target.id === "qv-add") {
            isDrawerOpen = false;
            refreshCartDrawer(true);
            document.getElementById("quick-view-popup")?.classList.remove("visible");
            document.querySelector(".wrapper-screen")?.classList.remove("visible");
          } else {
            window.location.href = "/checkout";
          }
        })
        .catch(() => {
          alert("Action failed.");
          hideLoader();
        });
    }
  });


  document.body.addEventListener("click", function (e) {
    const isQtyButton = e.target.closest(".cart__quantity-minus") || e.target.closest(".cart__quantity-plus") || e.target.closest(".quick-add__button");
    const isRemoveButton = e.target.closest(".cart__item__remove");

    if (isQtyButton || isRemoveButton) {
      const drawerItems = document.querySelector(".drawer__items");
      if (!drawerItems) return;

      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            initSwiper();
            observer.disconnect();
            break;
          }
        }
      });

      observer.observe(drawerItems, { childList: true, subtree: true });
    }
  });

  initSwiper();
});  
*/





/*
document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;
  let isDrawerOpen = false;

  function initSwiper() {
    const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
    if (!container) return;

    if (swiperInstance && swiperInstance.destroy) {
      swiperInstance.destroy(true, true);
    }

    swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  function showLoader() {
    const loader = document.createElement("div");
    loader.id = "qv-loader";
    loader.style.position = "fixed";
    loader.style.top = 0;
    loader.style.left = 0;
    loader.style.width = "100%";
    loader.style.height = "100%";
    loader.style.background = "rgba(255,255,255,0.7) url('/spinner.gif') no-repeat center center";
    loader.style.zIndex = 9999;
    document.body.appendChild(loader);
  }

  function hideLoader() {
    const loader = document.getElementById("qv-loader");
    if (loader) loader.remove();
  }

  function initCartDrawerEvents() {
    // Quantity minus buttons
    document.querySelectorAll(".cart__quantity-minus").forEach(btn => {
      btn.addEventListener("click", function() {
        const input = this.nextElementSibling;
        input.value = Math.max(1, parseInt(input.value) - 1);
        updateCartItem(this.closest('.cart__item'), input.value);
      });
    });

    // Quantity plus buttons
    document.querySelectorAll(".cart__quantity-plus").forEach(btn => {
      btn.addEventListener("click", function() {
        const input = this.previousElementSibling;
        input.value = parseInt(input.value) + 1;
        updateCartItem(this.closest('.cart__item'), input.value);
      });
    });

    // Remove buttons
    document.querySelectorAll(".cart__item__remove").forEach(btn => {
      btn.addEventListener("click", function() {
        showLoader();
        fetch(this.dataset.url, { method: "POST" })
          .then(() => refreshCartDrawer())
          .finally(() => hideLoader());
      });
    });
  }

  function updateCartItem(itemElement, quantity) {
    if (!itemElement) return;
    
    const line = itemElement.dataset.line;
    if (!line) return;
    
    showLoader();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: parseInt(quantity)
      })
    })
    .then(response => response.json())
    .then(() => refreshCartDrawer())
    .catch(error => {
      console.error('Error updating cart:', error);
      refreshCartDrawer(); // Refresh anyway to reset to correct values
    })
    .finally(() => hideLoader());
  }

  function refreshCartDrawer(forceOpen = false) {
    fetch("/?sections=cart-drawer")
      .then(res => res.ok ? res.json() : Promise.reject(res.status))
      .then(data => {
        const drawerHTML = data['cart-drawer'];
        const drawerWrapper = document.querySelector(".drawer--cart");
        if (!drawerWrapper) return;

        const parser = new DOMParser();
        const newDoc = parser.parseFromString(drawerHTML, "text/html");
        const newDrawerContent = newDoc.querySelector(".drawer--cart");

        if (!newDrawerContent) return;

        const isOpen = drawerWrapper.classList.contains("is-open");

        // Replace entire drawer content to ensure all event listeners are fresh
        drawerWrapper.innerHTML = newDrawerContent.innerHTML;
        
        if (forceOpen || isOpen) {
          drawerWrapper.classList.add("is-open");
        }

        // Reinitialize all functionality
        initCartDrawerEvents();
        initSwiper();
        initThemeCartFunctions();
        
        hideLoader();
      })
      .catch(err => {
        console.error("Failed to refresh cart drawer:", err);
        hideLoader();
      });
  }

  function initThemeCartFunctions() {
    // Shopify theme functions
    if (typeof theme !== 'undefined') {
      if (typeof theme.cart !== 'undefined' && typeof theme.cart.init === 'function') {
        theme.cart.init();
      }
      if (typeof theme.initCartDrawer === 'function') {
        theme.initCartDrawer();
      }
    }
    
    // Custom theme functions
    if (typeof initCartDrawer === 'function') {
      initCartDrawer();
    }
    
    // Shopify default bindings
    if (typeof Shopify !== 'undefined' && typeof Shopify.bindAll === 'function') {
      Shopify.bindAll();
    }
  }

  // Quick View Product Handling
  document.body.addEventListener("click", function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (quickBtn) {
      const handle = quickBtn.dataset.handle;
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(product => {
          let imageHtml = product.images.map(img => `
            <div class="qv-image-slide">
              <img src="${img}" alt="${product.title}" style="max-width:100%;">
            </div>`).join('');

          const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || '';

          let wrapperHtml = `
            <h3 class="qv-title">${product.title}</h3>
            <p class="qv-price">Rs.${(product.price / 100).toFixed(2)}</p>
            <div class="qv-desc">${product.description}</div>
            <form id="qv-form">
              <label class="label-qw">Select Size: Choose an option</label><br>
              <select name="id" id="variant-pr">
                ${product.variants.map(v => `<option value="${v.id}">${v.title}</option>`).join('')}
              </select>
              <div class="quantity-wrapper">
                <button type="button" id="qv-minus">–</button>
                <input type="number" id="qv-qty" value="1" min="1">
                <button type="button" id="qv-plus">+</button>
              </div>
              <button type="button" id="qv-add">Add to cart</button>
              <button type="button" id="qv-buy-now">Buy it now</button>
              ${socialIcons}
            </form>`;

          const popup = document.getElementById("quick-view-popup");
          popup.innerHTML = `<span class="close-qw" style="cursor: pointer; position: sticky; top: -1px !important; right: 0px !important; font-size: 18px; margin-left: auto;">X</span><div class="qv-image">${imageHtml}</div><div class="qv-wrapper">${wrapperHtml}</div>`;
          popup.classList.add("visible");
          document.querySelector(".wrapper-screen")?.classList.add("visible");

          setTimeout(() => {
            if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
              $('.qv-image').slick({
                dots: false,
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
              });
            }
          }, 500);
        })
        .catch(err => {
          console.error("Fetch error:", err);
          alert("Unable to load product data.");
        });
    }

    // Close quick view
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    // Quick view quantity buttons
    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = parseInt(input.value) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) - 1);
    }

    // Quick view add to cart
    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      showLoader();
      const variantId = document.querySelector("#qv-form select[name='id']")?.value;
      const quantity = parseInt(document.querySelector("#qv-qty")?.value || 1);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(() => {
          refreshCartDrawer(true); // Force open drawer
          document.getElementById("quick-view-popup")?.classList.remove("visible");
          document.querySelector(".wrapper-screen")?.classList.remove("visible");

          if (e.target.id === "qv-buy-now") {
            window.location.href = "/checkout";
          }
        })
        .catch(() => {
          alert("Action failed.");
          hideLoader();
        });
    }
  });

  // Mutation observer for cart changes
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        initCartDrawerEvents();
        initSwiper();
        initThemeCartFunctions();
      }
    });
  });

  // Start observing the cart drawer
  const cartDrawer = document.querySelector('.drawer--cart');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Initialize everything
  initSwiper();
  initCartDrawerEvents();
  initThemeCartFunctions();
});  */


// ✅ DOM Ready
/*
document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;

  function initSwiper() {
    const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
    if (!container) return;
    if (swiperInstance && swiperInstance.destroy) swiperInstance.destroy(true, true);

    swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    });
  }

  function showLoader() {
    const loader = document.createElement("div");
    loader.id = "qv-loader";
    loader.style = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(255,255,255,0.7) url('/spinner.gif') no-repeat center center;
      z-index: 9999;
    `;
    document.body.appendChild(loader);
  }

  function hideLoader() {
    document.getElementById("qv-loader")?.remove();
  }

  function refreshCartInnerContent() {
    fetch("/?sections=cart-drawer")
      .then(res => res.ok ? res.json() : Promise.reject(res.status))
      .then(data => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data['cart-drawer'], "text/html");
        const newItems = newDoc.querySelector(".drawer__items");
        const newFooter = newDoc.querySelector(".cart__footer");
        const newUpsell = newDoc.querySelector(".cart-drawer__upsell");

        const currentItems = document.querySelector(".drawer__items");
        const currentFooter = document.querySelector(".cart__footer");
        const currentUpsell = document.querySelector(".cart-drawer__upsell");

        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
        if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
        if (newUpsell && currentUpsell) currentUpsell.innerHTML = newUpsell.innerHTML;

        initSwiper();
        hideLoader();

        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch(err => {
        console.error("Failed to refresh cart:", err);
        hideLoader();
      });
  }

  function bindCartUIEvents() {
    document.querySelectorAll(".cart__quantity-plus, .cart__quantity-minus, .cart__item__remove").forEach(btn => {
      btn.addEventListener("click", () => {
        setTimeout(refreshCartInnerContent, 300); // Delay to allow Shopify AJAX to complete
      });
    });
  }

  document.addEventListener("cart:updated", bindCartUIEvents);

  // ✅ Quick View Click
  document.body.addEventListener("click", function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (!quickBtn) return;
    const handle = quickBtn.dataset.handle;
    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then(res => res.ok ? res.json() : Promise.reject(res.status))
      .then(product => {
        const imageHtml = product.images.map(img => `<div class='qv-image-slide'><img src='${img}' style='max-width:100%;'></div>`).join("");
        const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || "";

        const popup = document.getElementById("quick-view-popup");
        popup.innerHTML = `
          <span class='close-qw'>X</span>
          <div class='qv-image'>${imageHtml}</div>
          <div class='qv-wrapper'>
            <h3>${product.title}</h3>
            <p>Rs. ${(product.price / 100).toFixed(2)}</p>
            <div class='qv-desc'>${product.description}</div>
            <form id='qv-form'>
              <select name='id'>${product.variants.map(v => `<option value='${v.id}'>${v.title}</option>`).join('')}</select>
              <div class='quantity-wrapper'>
                <button type='button' id='qv-minus'>–</button>
                <input type='number' id='qv-qty' value='1' min='1'>
                <button type='button' id='qv-plus'>+</button>
              </div>
              <button type='button' id='qv-add'>Add to cart</button>
              <button type='button' id='qv-buy-now'>Buy it now</button>
              ${socialIcons}
            </form>
          </div>`;

        popup.classList.add("visible");
        document.querySelector(".wrapper-screen")?.classList.add("visible");
      })
      .catch(() => alert("Failed to load product"));
  });

  // ✅ Quantity & Add to Cart
  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = parseInt(input.value) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) - 1);
    }

    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      const variantId = document.querySelector("#qv-form select[name='id']")?.value;
      const quantity = parseInt(document.querySelector("#qv-qty")?.value || 1);

      showLoader();
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:updated"));
          refreshCartInnerContent();
          document.getElementById("quick-view-popup")?.classList.remove("visible");
          document.querySelector(".wrapper-screen")?.classList.remove("visible");
          if (e.target.id === "qv-buy-now") window.location.href = "/checkout";
        })
        .catch(() => alert("Failed to add to cart"))
        .finally(hideLoader);
    }
  });

  initSwiper();
  bindCartUIEvents();
});

*/
/*
Good
let swiperInstance;

function initSwiper() {
  const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
  if (!container) return;

  if (swiperInstance && swiperInstance.destroy) {
    swiperInstance.destroy(true, true);
  }

  swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

function updateCartSubtotalUI() {
  const priceHolder = document.querySelector('[data-cart-price-holder]');
  if (!priceHolder) return;

  // Show loader
  priceHolder.classList.add('loading');
  const loader = priceHolder.querySelector('.cart__price__loader');
  if (loader) loader.style.display = 'block';

  fetch('/cart.js')
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(cart => {
      const totalPrice = cart.total_price;
      const formatted = new Intl.NumberFormat("en-PK", {
        style: "currency",
        currency: "PKR"
      }).format(totalPrice / 100);

      const priceSpan = priceHolder.querySelector('[data-cart-total]');
      if (priceSpan) {
        priceSpan.textContent = formatted + " PKR";
        priceSpan.setAttribute("data-cart-total", totalPrice);
      }
    })
    .catch(err => console.error("Failed to update subtotal:", err))
    .finally(() => {
      priceHolder.classList.remove('loading');
      if (loader) loader.style.display = 'none';
    });
}

function refreshCartInnerContent() {
  return fetch("/?sections=cart-drawer")
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(data => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], "text/html");

      const newItems = newDoc.querySelector(".drawer__items");
      const newFooter = newDoc.querySelector(".cart__footer");
      const newUpsell = newDoc.querySelector(".cart-drawer__upsell");

      const currentItems = document.querySelector(".drawer__items");
      const currentFooter = document.querySelector(".cart__footer");
      const currentUpsell = document.querySelector(".cart-drawer__upsell");

      if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
      if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
      if (newUpsell && currentUpsell) currentUpsell.innerHTML = newUpsell.innerHTML;

      document.dispatchEvent(new CustomEvent("cart:updated"));
      updateCartSubtotalUI(); // ✅ update price
    })
    .catch(err => console.error("Failed to refresh cart:", err));
}

function bindCartDrawerButtons() {
  const replaceWithClone = (selector) => {
    document.querySelectorAll(selector).forEach(btn => {
      const clone = btn.cloneNode(true);
      btn.replaceWith(clone);
    });
  };

  replaceWithClone(".cart__quantity-plus");
  replaceWithClone(".cart__quantity-minus");
  replaceWithClone(".cart__item__remove");

  const updateCartQuantity = async (id, quantity) => {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity })
    });
    await refreshCartInnerContent();
    updateCartSubtotalUI(); // ✅ update subtotal after quantity change
  };

  document.querySelectorAll(".cart__quantity-plus").forEach(btn => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
      const id = input.dataset.id;
      const qty = parseInt(input.value) || 1;
      updateCartQuantity(id, qty + 1);
    });
  });

  document.querySelectorAll(".cart__quantity-minus").forEach(btn => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
      const id = input.dataset.id;
      const qty = parseInt(input.value) || 1;
      updateCartQuantity(id, Math.max(1, qty - 1));
    });
  });

  document.querySelectorAll(".cart__item__remove").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const id = btn.getAttribute("data-id");
      updateCartQuantity(id, 0);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiper();
  bindCartDrawerButtons();
  bindQuickViewPopup();

  document.body.addEventListener("click", function (e) {
    const isQtyButton = e.target.closest(".cart__quantity-minus") || e.target.closest(".cart__quantity-plus") || e.target.closest(".quick-add__button");
    const isRemoveButton = e.target.closest(".cart__item__remove");

    if (isQtyButton || isRemoveButton) {
      const drawerItems = document.querySelector(".drawer__items");
      if (!drawerItems) return;

      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            initSwiper();
            observer.disconnect();
            break;
          }
        }
      });

      observer.observe(drawerItems, { childList: true, subtree: true });
    }
  });
});

document.addEventListener("cart:updated", () => {
  bindCartDrawerButtons();
  initSwiper();
  updateCartSubtotalUI(); // ✅ always update subtotal on cart update
});

// QUICK VIEW
function bindQuickViewPopup() {
  document.body.addEventListener("click", async function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (!quickBtn) return;

    const handle = quickBtn.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Failed to fetch product");
      const product = await res.json();

      const imageHtml = product.images.map(img => `
        <div class="qv-image-slide">
          <img src="${img}" alt="${product.title}" style="max-width:100%;">
        </div>`).join('');

      const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || '';

      const wrapperHtml = `
        <h3 class="qv-title">${product.title}</h3>
        <p class="qv-price">Rs.${(product.price / 100).toFixed(2)}</p>
        <div class="qv-desc">${product.description}</div>
        <form id="qv-form">
          <label class="label-qw">Select Size: Choose an option</label><br>
          <select name="id" id="variant-pr">
            ${product.variants.map(v => `<option value="${v.id}">${v.title}</option>`).join('')}
          </select>
          <div class="quantity-wrapper">
            <button type="button" id="qv-minus">–</button>
            <input type="number" id="qv-qty" value="1" min="1">
            <button type="button" id="qv-plus">+</button>
          </div>
          <button type="button" id="qv-add">Add to cart</button>
          <button type="button" id="qv-buy-now">Buy it now</button>
          ${socialIcons}
        </form>`;

      const popup = document.getElementById("quick-view-popup");
      popup.innerHTML = `
        <span class="close-qw" style="cursor:pointer;position:sticky;top:-1px;right:0;font-size:18px;margin-left:auto;">X</span>
        <div class="qv-image">${imageHtml}</div>
        <div class="qv-wrapper">${wrapperHtml}</div>`;

      popup.classList.add("visible");
      document.querySelector(".wrapper-screen")?.classList.add("visible");

      setTimeout(() => {
        if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
          $('.qv-image').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }, 500);
    } catch (err) {
      console.error("Popup fetch error:", err);
      alert("Unable to load product data.");
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = parseInt(input.value) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) - 1);
    }

    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      const variantId = document.querySelector("#qv-form select[name='id']")?.value;
      const quantity = parseInt(document.querySelector("#qv-qty")?.value || 1);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(() => {
          document.getElementById("quick-view-popup")?.classList.remove("visible");
          document.querySelector(".wrapper-screen")?.classList.remove("visible");
          refreshCartInnerContent().then(() => {
            document.dispatchEvent(new CustomEvent("cart:updated"));
            updateCartSubtotalUI(); // ✅ update subtotal here too
          });
        })
        .catch(() => alert("Action failed."));
    }
  });
}
Good
*/

let swiperInstance;

function initSwiper() {
  const container = document.querySelector(".cart-drawer__upsell.custom .upsell-products.rel");
  if (!container) return;

  if (swiperInstance && swiperInstance.destroy) {
    swiperInstance.destroy(true, true);
  }

  swiperInstance = new Swiper(".cart-drawer__upsell.custom .upsell-products.rel", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

function updateCartSubtotalUI() {
  const priceHolder = document.querySelector('[data-cart-price-holder]');
  if (!priceHolder) return;

  priceHolder.classList.add('loading');
  const loader = priceHolder.querySelector('.cart__price__loader');
  if (loader) loader.style.display = 'block';

  fetch('/cart.js')
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(cart => {
      const totalPrice = cart.total_price;
      const formatted = new Intl.NumberFormat("en-PK", {
        style: "currency",
        currency: "PKR"
      }).format(totalPrice / 100);

      const priceSpan = priceHolder.querySelector('[data-cart-total]');
      if (priceSpan) {
        priceSpan.textContent = formatted + " PKR";
        priceSpan.setAttribute("data-cart-total", totalPrice);
      }
    })
    .catch(err => console.error("Failed to update subtotal:", err))
    .finally(() => {
      priceHolder.classList.remove('loading');
      if (loader) loader.style.display = 'none';
    });
}

function refreshCartInnerContent() {
  return fetch("/?sections=cart-drawer")
    .then(res => res.ok ? res.json() : Promise.reject(res.status))
    .then(data => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], "text/html");

      const newItems = newDoc.querySelector(".drawer__items");
      const newFooter = newDoc.querySelector(".cart__footer");
      const newUpsell = newDoc.querySelector(".cart-drawer__upsell");

      const currentItems = document.querySelector(".drawer__items");
      const currentFooter = document.querySelector(".cart__footer");
      const currentUpsell = document.querySelector(".cart-drawer__upsell");

      if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
      if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
      if (newUpsell && currentUpsell) currentUpsell.innerHTML = newUpsell.innerHTML;

      document.dispatchEvent(new CustomEvent("cart:updated"));
      updateCartSubtotalUI();
    })
    .catch(err => console.error("Failed to refresh cart:", err));
}

function bindCartDrawerButtons() {
  const replaceWithClone = (selector) => {
    document.querySelectorAll(selector).forEach(btn => {
      const clone = btn.cloneNode(true);
      btn.replaceWith(clone);
    });
  };

  replaceWithClone(".cart__quantity-plus");
  replaceWithClone(".cart__quantity-minus");
  replaceWithClone(".cart__item__remove");

  const updateCartQuantity = async (id, quantity) => {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity })
    });
    await refreshCartInnerContent();
    updateCartSubtotalUI();
  };

  document.querySelectorAll(".cart__quantity-plus").forEach(btn => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
      const id = input.dataset.id;
      const qty = parseInt(input.value) || 1;
      updateCartQuantity(id, qty + 1);
    });
  });

document.querySelectorAll(".cart__quantity-minus").forEach(btn => {
  btn.addEventListener("click", () => {
    const input = btn.closest(".cart__quantity").querySelector(".cart__quantity-field");
    const id = input.dataset.id;
    const qty = parseInt(input.value) || 1;

    if (qty === 1) {
      updateCartQuantity(id, 0); // ❌ Remove product
    } else {
      updateCartQuantity(id, qty - 1); // ➖ Decrease quantity
    }
  });
});



  document.querySelectorAll(".cart__item__remove").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const id = btn.getAttribute("data-id");
      updateCartQuantity(id, 0);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiper();
  bindCartDrawerButtons();
  bindQuickViewPopup();

  document.body.addEventListener("click", function (e) {
    const isQtyButton = e.target.closest(".cart__quantity-minus") || e.target.closest(".cart__quantity-plus") || e.target.closest(".quick-add__button");
    const isRemoveButton = e.target.closest(".cart__item__remove");

    if (isQtyButton || isRemoveButton) {
      const drawerItems = document.querySelector(".drawer__items");
      if (!drawerItems) return;

      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            initSwiper();
            observer.disconnect();
            break;
          }
        }
      });

      observer.observe(drawerItems, { childList: true, subtree: true });
    }
  });
});

document.addEventListener("cart:updated", () => {
  bindCartDrawerButtons();
  initSwiper();
  updateCartSubtotalUI();
});

function bindQuickViewPopup() {
  document.body.addEventListener("click", async function (e) {
    const quickBtn = e.target.closest(".quick-view");
    if (!quickBtn) return;

    const handle = quickBtn.dataset.handle;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Failed to fetch product");
      const product = await res.json();

      const imageHtml = product.images.map(img => `
        <div class="qv-image-slide">
          <img src="${img}" alt="${product.title}" style="max-width:100%;">
        </div>`).join('');

      const socialIcons = document.getElementById("social-icons-wrapper")?.innerHTML || '';

      const wrapperHtml = `
        <h3 class="qv-title">${product.title}</h3>
        <p class="qv-price">Rs.${(product.price / 100).toFixed(2)}</p>
        <div class="qv-desc">${product.description}</div>
        <form id="qv-form">
          <label class="label-qw">Select Size: Choose an option</label><br>
          <select name="id" id="variant-pr">
            ${product.variants.map(v => `<option value="${v.id}">${v.title}</option>`).join('')}
          </select>
          <div class="quantity-wrapper">
            <button type="button" id="qv-minus">–</button>
            <input type="number" id="qv-qty" value="1" min="1">
            <button type="button" id="qv-plus">+</button>
          </div>
          <button type="button" id="qv-add">Add to cart</button>
          <button type="button" id="qv-buy-now">Buy it now</button>
          ${socialIcons}
        </form>`;

      const popup = document.getElementById("quick-view-popup");
      popup.innerHTML = `
        <span class="close-qw" style="cursor:pointer;position:sticky;top:-1px;right:0;font-size:18px;margin-left:auto;">X</span>
        <div class="qv-image">${imageHtml}</div>
        <div class="qv-wrapper">${wrapperHtml}</div>`;

      popup.classList.add("visible");
      document.querySelector(".wrapper-screen")?.classList.add("visible");

      setTimeout(() => {
        if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
          $('.qv-image').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }, 500);
    } catch (err) {
      console.error("Popup fetch error:", err);
      alert("Unable to load product data.");
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("wrapper-screen") || e.target.classList.contains("close-qw")) {
      document.getElementById("quick-view-popup")?.classList.remove("visible");
      document.querySelector(".wrapper-screen")?.classList.remove("visible");
    }

    if (e.target.id === "qv-plus") {
      const input = document.getElementById("qv-qty");
      input.value = parseInt(input.value) + 1;
    } else if (e.target.id === "qv-minus") {
      const input = document.getElementById("qv-qty");
      input.value = Math.max(1, parseInt(input.value) - 1);
    }

    if (e.target.id === "qv-add" || e.target.id === "qv-buy-now") {
      const variantId = document.querySelector("#qv-form select[name='id']")?.value;
      const quantity = parseInt(document.querySelector("#qv-qty")?.value || 1);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity })
      })
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(() => {
          document.getElementById("quick-view-popup")?.classList.remove("visible");
          document.querySelector(".wrapper-screen")?.classList.remove("visible");
          refreshCartInnerContent().then(() => {
            document.dispatchEvent(new CustomEvent("cart:updated"));
            updateCartSubtotalUI();
          });
        })
        .catch(() => alert("Action failed."));
    }
  });
}

//
// ✅ ADD THIS FINAL BLOCK FOR PRODUCT PAGE Add-to-Cart REINIT
//
document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", function (e) {
    const productAddBtn = e.target.closest(".product__submit__item .btn");
    if (!productAddBtn) return;

    // Optional: disable temporarily
    productAddBtn.disabled = true;

    setTimeout(() => {
      refreshCartInnerContent().then(() => {
        initSwiper(); // ✅ Reinitialize Swiper
        productAddBtn.disabled = false;
      });
    }, 800); // adjust delay if needed
  });
});
// document.addEventListener("cart:updated", () => {
//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cart => {
//       const count = cart.item_count;

//       // 🛒 Console Log
//       console.log(`🛒 Cart Updated → Total Items: ${count}`);

//       // 🖼️ Update UI
//       const statusEl = document.querySelector(".navlink--cart--icon .header__cart__status");
//       if (statusEl) {
//         statusEl.textContent = count; // sirf number
//         // Agar "Items" bhi likhna ho:
//         // statusEl.textContent = `${count} items`;
//       }
//     })
//     .catch(err => console.error("Failed to fetch cart count:", err));
// });









